module.exports = __webpack_public_path__ + "static/media/2S.dae560c9.svg";